import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AdvisorRepository } from '../../../domain/repositories/advisor/advisor.repository';
import { AdvisorService } from '../../services/advisor/advisor.service';
import { AdvisorResponse, AdvisorSingularData } from '../../../domain/interfaces/advisor/advisor.interface';

/**
 * Implementación del repositorio de datos iniciales
 * Usa el InitialDataService para obtener los datos del API
 */
@Injectable({
  providedIn: 'root',
})
export class AdvisorRepositoryImplementation extends AdvisorRepository {
  private readonly AdvisorService = inject(AdvisorService);


  getAdvisorInformation(sessionId: string, BodyAdvisor: string): Observable<AdvisorSingularData> {
    return this.AdvisorService.getAdvisorInformation(sessionId, BodyAdvisor);
  }


  getAdvisorsList(sessionId: string): Observable<AdvisorResponse> {
    return this.AdvisorService.getAdvisorsList(sessionId);
  } 
}
